/**
 * GritVue Crew Rewards · front end only.
 * Tracking, unique codes, balances and payouts will be handled by a real
 * Shopify referral / affiliate app. Nothing here fakes a balance or a sale.
 *
 * Leave a URL empty until it exists: its button shows "Coming soon" and the
 * page offers an email signup instead of a broken link.
 */
export const REFERRAL_PROGRAM_URL = ''
export const REFERRAL_DASHBOARD_URL = ''
export const REFERRAL_TERMS_URL = ''

export const REFERRAL_WAITLIST_MAILTO =
  'mailto:support@gritvuegear.com?subject=GritVue%20Crew%20Rewards&body=Please%20let%20me%20know%20when%20GritVue%20Crew%20Rewards%20opens.'

export const referralEconomics = {
  friendPercent: 10,
  friendMaxDiscount: 10,
  referrerReward: 15,
}

export const referralSteps = [
  { title: 'Get your link', body: 'Join Crew Rewards and get a personal referral link or code.' },
  { title: 'Share it', body: 'Your friend gets 10% off an eligible order, up to $10 off.' },
  { title: 'Get paid', body: 'You earn $15 for each qualified, completed order they place.' },
]

export const referralRules = [
  'Referred customers must be new to GritVue.',
  'Rewards are paid only on qualified, completed orders, after the return and fraud review window.',
  'Refunded, cancelled or fraudulent orders do not earn a reward.',
  'No self-referrals and no duplicate accounts.',
  'The friend discount is capped at $10 and does not combine with private offers or other discount codes.',
  'Crew Rewards program terms apply.',
]
